import React from 'react';

/*
import {
  hf,
  hfDTM,
  ht,
  cr,
  useMsgz,
  a,
  ls,
  f,
  gs,
  BoxC,
  BtnC,
  CbxC,
  LblC,
  GridC,
  IptC,
  TextC,
  _cv_51___Mz,
  _cv_60___Mz,
//  useSrpz,
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as IptC from "./_ccbIptC";
import * as TextC from "./_ccbTextC";
import * as GridC from "./_cccGridC";
import * as CbxC from "./_cccCbxC";
import * as BtnC from "./_cccBtnC";
import * as LblC from "./_cccLblC";
import * as cmFTH from "./_cmFTH"; // 廃止予定
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as gs from "./_csGbl";
import * as ls from "./_csLcl"; // local state
import { useMsgz } from "./_csMdlMsg";
import * as _cv_51___Mz from "./_cv_51___Mz";
import * as _cv_60___Mz from "./_cv_60___Mz";
import * as ht from './_ht';
import * as hf from './_hf';
import * as hfDTM from './_hfDTM';

import * as ihd from './ihd';
import * as icm from './icm';
import * as icv from './icv';
//import * as ict from './ict';

import * as icvI1z___Mz from './icvI1z___Mz';
import * as icvI17___Tz from './icvI17___Tz';
import * as icvI1z___TzAby from './icvI1z___TzAby';
import * as IcvI1z___TzCnt from './icvI1z___TzCnt';

let $i111s = [] as ht.ls;
let $i10rz = { _fst: -1, } as ht.dz | undefined;
let $dtmz = {} as ht.dz;
let $cnt = 0;
let $_51Rw = {} as ht.dz;
let $_601s = [] as ht.ls;

export const N = (pz: {
  sPz: ht.dz,
  cz: {
    i10rs: ht.ls,
    i17rs: ht.ls,
    i1zz: ht.dz,
  }
}) => {

  const _udtThis = ls.udtThis();
  const _sMsgz = useMsgz();

//  const _sSrpz = useSrpz();

  const _gUserz = gs.useUserz();
  const _gStgz = gs.useStgz();

//hf.l(`icvI1zD10Co1 57: ${pz.sPz.crt._31rz?._fst}`);

  React.useEffect(()=> { // この画面で初めて _31r を特定できるため、_31r に紐づく設定を読み込み直している
    cmFTH.loadAllAsync({
      frcUdt: _udtThis,
      bfrAsync: () => [
        new Promise( async _exit => {
          $dtmz = await icm.grtCdrDtmzAsync({
            ctt: pz.sPz.crt.ctt,
            _31r_fst: pz.sPz.crt._31rz._fst,
          });
          _exit(undefined);
        }),
        new Promise( _exit => {
          $i10rz = hf.getDz(pz.cz.i10rs, hf.get1(pz.cz.i1zz.i1z1s)?.i1z1i10r1f ?? -1, '_fst')
          $i111s = hf.get1($i10rz?.cldz.i11rs)?.cldz?.i111s ?? [];
          _exit(null);
        }),
        icvI1z___Mz.loadI1zrLsAsync({
          _31r_fst: pz.sPz.crt._31rz._fst,
          i18r_fst: _gUserz.crt.i18rz._fst,
          i1zrd3100sStt: _gStgz.crt.alyMthSttDate,
          i1zrd3100sEnd: _gStgz.crt.alyMthEndDate,
          i1zrs1200iMnm: 60,
        }).then((_ls: ht.ls) => {
          $cnt = (_ls.length ?? 0) + 1;
        })
      ],
    });
  }, [
    pz.cz.i1zz,
    pz.sPz.crt.phs,
  ]);

  React.useEffect(() => {
    hf.ectSrlAsync([
      async () => {
        const _date = pz.cz.i1zz.i1zrz.i1zrd3100s ?? hfDTM.getTdy();
        $_601s = await _cv_60___Mz.load_601AsAsync({ // 祝日
          dates: hfDTM.grtDates(hfDTM.cvtFdm(_date), hfDTM.cvtLdm(_date)),
        });
        _udtThis();
      }
    ])
  }, [
    pz.cz.i1zz.i1zrz.i1zrd3100s
  ])

  React.useEffect(() => {
    hf.ectSrlAsync([
      async () => {
        $_51Rw = await _cv_51___Mz.load_51rRzAsync({
          _31r_fst: pz.sPz.crt._31rz._fst,            
        });
//hf.l(`icvI1zD10Co1 67b: ${hf.s($_51Rw)}`);
        _udtThis();
      }
    ])
  }, [
    pz.sPz.crt._31rz._fst
  ])

  const _zonez = {} as ht.dz;
  pz.cz.i1zz?.i1z1s?.map( (_i1z1z: ht.dz) => {
    _zonez[_i1z1z.i1z1i1111f] = _i1z1z._dlt != 1 ? 1 : -1;
  });

//hf.l(`icvI1zD10Co1 91: ${hf.s($dtmz)} '${pz.cz.i1zz.i1zrz?.i1zrd3100s}'`);
//hf.l(`icvI1zD10Co1 109a: ${_gStgz.crt.S01999232}, ${pz.cz.i1zz?.i1zrz?.i1zrd3100s}, ${hf.f(pz.cz.i1zz?.i1zrz?.i1zrd3100s)}, ${$i10rz?._fst}`);
//hf.l(`icvI1zD10Co1 109a: ${$_51Rw.S01999232}`);
//hf.l(`icvI1zD10Co1 109b: ${_gStgz.crt.rsvEndDate}, ${hf.s(_gStgz.crt)}`);
//hf.l(`icvI1zD10Co1 109c: ${hf.s(_gUserz.crt)}`);
//hf.l(`icvI1zD10Co1 109d: ${hf.s(pz.sPz.crt)}`);

  return ( // このページでは、_31r を特定できているため _gStgz を指定する必要がある

    cr.c(BoxC.N, {
      key: -10,
      abtType: 'baseAreaz',
      oClds: [

        cr.c(BoxC.N, {
          key: -10,
          abtType: 'topAreaz',
          oClds: [

            pz.sPz.crt.ctt == 'r'?
            cr.c(TextC.N, {
              key: -10,
              abtType: 'wrn2z',
              boxStlz: a('mb/2'),
              textz: {
                pfx: `${_gStgz.crt.rsvSttDate} より前の利用予約は web で行うことができません。直接電話か窓口にてお申し込みください。`,
              },
            })
            : null,

            cr.c(GridC.N, {
              key: -20,
              abtType: 'brdAltz',
              boxStlz: a('dw/40 mb/2'),
              lineCs: [
                {
                  cellCs: [
                    {
                      oClds: [
                        cr.c(TextC.N, {
                          key: -10,
                          textz: {
                            pfx: `受付中の${pz.sPz.crt.dffz.tgt}`,
                            stlz: a('tb tc/lt1 ts/l'),
                          },
                        })
                      ]
                    }
                  ]
                },
                {
                  cellCs: [
                    {
                      oClds: [
                        cr.c(TextC.N, {
                          key: -10,
                          boxStlz: a('dw/f fd/ccc pv/1 ph/2 sc/lt1'),
                          textz: {
                            pfx: 
                              pz.sPz.crt.ctt == 'r' ?
                                `${_gStgz.crt.rsvEndDate}利用予約分まで`
                              : pz.sPz.crt.ctt == 'e' && _gUserz.crt.i19rz?.i19ra4100i == 3 ?
                                `${hfDTM.f(_gStgz.crt.tgtSttDate, '年月', false)}〜${hfDTM.cvtMth(_gStgz.crt.tgtEndDate)}月 利用予約分`
                              : pz.sPz.crt.ctt == 'e' ?
                                `${hfDTM.f(_gStgz.crt.alyMth + '-01', '年月', false)} 利用予約分`
                              : '',
                            stlz: a('tb tc/rd5 ts/m'),
                          },
                        }),
                      ]
                    }
                  ]
                }
              ]
            }),

            pz.sPz.crt.ctt == 'r'?
            cr.c(TextC.N, {
              key: -30,
              textz: {
                pfx: `本日のあなたの${pz.sPz.crt.dffz.tgt}状況は、下記の通りです。`,
              },
              boxStlz: a('dw/f fd/ccc')
            })
            : null,

            pz.sPz.crt.ctt == 'r'?
            cr.c(IcvI1z___TzCnt.N, {
              key: -50,
              sPz: pz.sPz,
              cz: {
                i18r_fst: _gUserz.crt.i18rz._fst,
                sc: 'lm3',
                tc: 'lt9',
                tgtEndDate: _gStgz.crt.rsvEndDate,
              }
            })
            : null,

          ]
        }),

        pz.sPz.crt.ctt == 'e'?
        cr.c(TextC.N, {
          key: -20,
          boxStlz: a('dw/f fd/ccc mb/2'),
          textz: {
            pfx: `受付期間\n${hfDTM.f(_gStgz.crt.alySttDate, '年月日', false)} 〜 ${hfDTM.f(_gStgz.crt.alyEndDate, '年月日', false)}`,
            stlz: a('ta/c tb tc/rd5 ts/l'),
          },
        })
        : null,

        pz.sPz.crt.ctt == 'e' && _gUserz.crt.i19rz?.i19ra4100i == 3 ?
        cr.c(TextC.N, {
          key: -32,
          textz: {
            pfx: `本日のあなたの${pz.sPz.crt.dffz.tgt}状況は、下記の通りです。`,
          },
          boxStlz: a('dw/f fd/ccc')
        })
        : null,

        pz.sPz.crt.ctt == 'e' && _gUserz.crt.i19rz?.i19ra4100i == 3 ?
        cr.c(IcvI1z___TzCnt.N, {
          key: -34,
          sPz: pz.sPz,
          cz: {
            ctt: 'e',
            i18r_fst: _gUserz.crt.i18rz._fst,
            sc: 'bl3',
            tc: 'lt9',
            tgtSttDate: _gStgz.crt.tgtSttDate
          }
        })
        : null,

        pz.sPz.crt.ctt == 'e' && _gUserz.crt.i19rz?.i19ra4100i != 3 ?
        cr.c(TextC.N, {
          key: -30,
          textz: {
            //pfx: `このエントリーは、全 ${_gStgz.crt.S07010212}件中 ${$cnt}件目です。`,
            pfx: `このエントリーは、全 ${$_51Rw.S07010212}件中 ${$cnt}件目です。`,
            stlz: a('tb ts/l'),
          },
          boxStlz: a('dh/6 dw/f fd/ccc')
        })
        : null,

        cr.c(BoxC.N, {
          key: -40,
          boxStlz: a('dw/f fd/rac mb/2'),
          abtType: 'msgAreaz',
          oClds: [

            cr.c(GridC.N, {
              key: -20,
              abtType: 'brdMsgz',
              lineCs: [
                {
                  cellCs: [
                    {
                      oClds: [
                        cr.c(TextC.N, {
                          key: -10,
                          textz: {
                            pfx: '★ 利用を希望する部屋・日時を入力してください。',
                            stlz: a('tb tc/rd5 ts/l'),
                          },
                        })
                      ]
                    }
                  ]
                },
              ]
            }),

          ]
        }),

        cr.c(BoxC.N, {
          key: -50,
          boxStlz: 
            cr.d('p') ?
              a('dw/f fd/ras mb/4')
            : a('dw/f fd/csc mb/4'),
          oClds: [

            cr.c(BtnC.N, {
              key: -10,
              abtType: 'fcyz',
              lblCz: {
                textz: {
                  pfx: '利用時間帯・料金・定員\n・各室詳細等の確認',
                  stlz: a(`ta/c`),
                },
              },
              pslPtyz: {
                onPress: () => {
                  cr.openUrl({
                    url: pz.sPz.crt.i191z.i191a1100s
                  });
                },
              },
            }),

            cr.chkDvc() != 'p' ?
            cr.c(BoxC.N, {
              key: -20,
              boxStlz: a('dh/2'),
            })
            : null,

            cr.c(BtnC.N, {
              key: -30,
              abtType: 'sttz',
              lblCz: {
                textz: {
                  pfx: `${pz.sPz.crt.dffz.tgt}状況を確認`,
                },
              },
              pslPtyz: {
                onPress: () => {
                  cr.openUrl({
                    url: `${icv.appz.urlw}/stt?c=${pz.sPz.crt.ctt}&d=${hf.cvtNbr('e', _gUserz.crt._dmn, icv.srtz.nbrz4)}&i=${hf.cvtNbr('e', pz.sPz.crt._31rz._icn, icv.srtz.nbrz4)}&a=${(pz.sPz.crt.ctt == 'e' && _gUserz.crt.i19rz?.i19ra4100i == 3) ? 3 : (pz.sPz.crt.ctt == 'e' && _gUserz.crt.i19rz?.i19ra4100i != 3) ? 2 : 0}`,
                  });
                },
              },
            }),
          ]
        }),

        cr.c(BoxC.N, {
          key: -60,
          abtType: 'mainAreaz',
          boxStlz: a(`sc/${pz.sPz.crt.dffz.clr}1`),
          oClds: [

            cr.c(LblC.N, {
              key: -10,
              abtType: 
                cr.d('p') ?
                  `hzlDntz`
                : `vclDntz`,
              boxStlz: 
                cr.d('p') ?
                  a(`bc/${pz.sPz.crt.dffz.clr}5 bwl/4 dw/60 mb/0.5 pl/1`)
                : a(`bc/${pz.sPz.crt.dffz.clr}5 bwl/4 dw/40 mb/0.5 pl/1`),
              lblCz: {
                boxStlz: a('dw/20'),
                textz: {
                  pfx: '利用を希望する月',
                  stlz: a(`tc/${pz.sPz.crt.dffz.clr}7`),
                }
              },
              cttCz: {
                oClds: [
                  cr.c(IptC.S, {
                    key: -10,
                    cz: {
                      iptType: 'pcr',
                      ls: 
                        _gUserz.crt.i19rz?.i19ra4100i == 3 && pz.sPz.crt.ctt == 'e'? // 泉寿荘
                          hf.getRng(3).map((_nbr: ht.n) => { // 泉寿荘は5ヶ月
                            const _date = hfDTM.addMth(hfDTM.cvtFdm(hfDTM.getTdy()), _nbr - 1 + 3);
                            return {
                              key: hfDTM.f(_date, 'YYYY-MM'), pfx: hfDTM.f(_date, 'YYYY-MM')
                            }
                          })
                        : _gUserz.crt.i19rz?.i19ra4100i == 3 && pz.sPz.crt.ctt == 'r'? // 泉寿荘
//                          hf.getRng(3).map((_nbr: ht.n) => {
                          hf.getRng(_gStgz.crt.rsvMthCnt).map((_nbr: ht.n) => { // icm.
                            const _date = hfDTM.addMth(hfDTM.cvtFdm(hfDTM.getTdy()), _nbr - 1);
                            return {
                              key: hfDTM.f(_date, 'YYYY-MM'), pfx: hfDTM.f(_date, 'YYYY-MM')
                            }
                          })
                        : pz.sPz.crt.ctt == 'e'?
                          hf.getRng(3,3).map((_nbr: ht.n) => {
                            const _date = hfDTM.addMth(hfDTM.cvtFdm(hfDTM.getTdy()), _nbr - 1)
                            return {
                              key: hfDTM.f(_date, 'YYYY-MM'), pfx: hfDTM.f(_date, 'YYYY-MM')
                            }
                          })
                        :
                          hf.getRng(3).map((_nbr: ht.n) => {
                            const _date = hfDTM.addMth(hfDTM.cvtFdm(hfDTM.getTdy()), _nbr - 1)
                            return {
                              key: hfDTM.f(_date, 'YYYY-MM'), pfx: hfDTM.f(_date, 'YYYY-MM')
                            }
                          })
                        ,
                        vle: hfDTM.f(pz.cz.i1zz.i1zrz?.i1zrd3100s, 'YYYY-MM'),
                      onChg: ( _dz: ht.dz ) => {
                        pz.cz.i1zz.i1zrz.i1zrd3100s = _dz.key + '-01';
                        pz.sPz.udtAll();
                      },
                    },
                  })
                ]
              }
            }),

            cr.c(LblC.N, {
              key: -30,
              abtType: 
                cr.d('p') ?
                  `hzlDntz`
                : `vclDntz`,
              boxStlz: 
                cr.d('p') ?
                  a(`bc/${pz.sPz.crt.dffz.clr}5 bwl/4 dw/60 mb/2 pl/1`)
                : a(`bc/${pz.sPz.crt.dffz.clr}5 bwl/4 dw/40 mb/2 pl/1`),
              lblCz: {
                boxStlz: a('dw/20'),
                textz: {
                  pfx: '利用する部屋',
                  stlz: a(`tc/${pz.sPz.crt.dffz.clr}7`),
                }
              },
              cttCz: {
                oClds: [
                  cr.c(IptC.S, {
                    key: -10,
                    cz: {
                      bEdit: true,
                      iptType: 'pcr',
                      ls: pz.cz.i10rs,
                      vle: $i10rz?._fst,
                      onChg: ( _dz: ht.dz ) => {
                        $i10rz = _dz;
                        $i111s = hf.get1(_dz.cldz?.i11rs)?.cldz.i111s;

                        const _i1z1s = [] as ht.ls;
                        $i111s?.map((_i111z: ht.dz) => { // 利用する日と同一の処理
                          const _dz1 = icm.grtI1z1z({
                            i1z1d1100s: pz.cz.i1zz.i1zrz.i1zrd3100s,
                            i10r_fst: $i10rz?._fst,
                            i10rs: pz.cz.i10rs,
                            i111_fst: Number(_i111z._fst),
                            i15ra6100i: _gUserz.crt.i15rz.i15ra6100i,
                            _601s: $_601s,
                          });
                          const _dz2 = {
                            ... ihd.i('i1z1'),
                            ... _dz1,
                            i1z1i1111f: _i111z._fst,
                            _dlt: 1,
                          }; 
                          _i1z1s.push(_dz2);
                        })
                        pz.cz.i1zz.i1z1s = _i1z1s;

                        _udtThis();

                      },
                    },
                  })
                ]
              }
            }),

            hf.f(pz.cz.i1zz?.i1zrz?.i1zrd3100s) && $i10rz?._fst > 0 ?
            cr.c(icvI1z___TzAby.V3, {
              key: -40,
              sPz: pz.sPz,
              boxStlz: a('mb/2'),
              cz: {
                bEdit: false,
                bNext: false,
                i10r_fsts: [$i10rz?._fst],
                date: pz.cz.i1zz.i1zrz.i1zrd3100s ?? hfDTM.getTdy(),
                i1zz: pz.cz.i1zz,
                _31r_fst: pz.sPz.crt._31rz._fst,
                row: cr.d('p') ? 1 : 2,
                role: 'd',
              }
            })
            : null,

            $i10rz?._fst > 0 ?
            cr.c(LblC.N, {
              key: -50,
              abtType: 
                cr.d('p') ?
                  `hzlDntz`
                : `vclDntz`,
              boxStlz: 
                cr.d('p') ?
                  a(`bc/${pz.sPz.crt.dffz.clr}5 bwl/4 dw/60 mb/0.5 pl/1`)
                : a(`bc/${pz.sPz.crt.dffz.clr}5 bwl/4 dw/40 mb/0.5 pl/1`),
              lblCz: {
                boxStlz: a('dw/20'),
                textz: {
                  pfx: '利用を希望する日',
                  stlz: a(`tc/${pz.sPz.crt.dffz.clr}7`),
                }
              },
              cttCz: {
                oClds: [
                  cr.c(IptC.S, {
                    key: -10,
                    cz: {
                      iptType: 'dtm',
                      dtmz: $dtmz,
                      vle: pz.cz.i1zz.i1zrz?.i1zrd3100s,
                      onChg: ( _s: ht.s ) => {
                        pz.cz.i1zz.i1zrz.i1zrd3100s = _s;

                        const _i1z1s = [] as ht.ls;
                        $i111s?.map((_i111z: ht.dz) => { // 部屋と同一の処理、日によって時間帯が異なることへの対応に必要
                          const _dz1 = icm.grtI1z1z({
                            i1z1d1100s: pz.cz.i1zz.i1zrz.i1zrd3100s,
                            i10r_fst: $i10rz?._fst,
                            i10rs: pz.cz.i10rs,
                            i111_fst: Number(_i111z._fst),
                            i15ra6100i: _gUserz.crt.i15rz.i15ra6100i,
                            _601s: $_601s,
                          });
                          const _dz2 = {
                            ... ihd.i('i1z1'),
                            ... _dz1,
                            i1z1i1111f: _i111z._fst,
                            _dlt: 1,
                          }; 
                          _i1z1s.push(_dz2);
                        })
                        pz.cz.i1zz.i1z1s = _i1z1s;

                        pz.sPz.udtAll();
                      },
                    },
                  })
                ]
              }
            })
            : undefined,

            $i10rz?._fst > 0 && pz.sPz.crt.ctt == 'r' ?
            cr.c(TextC.N, {
              key: -20,
              boxStlz: 
                cr.d('p') ?
                  a(`dw/60 mb/2`)
                : a(`dw/40 mb/2`),
              textz: {
                pfx: `※ ${_gStgz.crt.rsvSttDate} より前の利用予約は直接お問い合わせ下さい。`,
                stlz: a('tc/rd5 ts/s'),
              }
            })
            : null,

            $i10rz?._fst > 0 ?
            cr.c(LblC.N, {
              key: -60,
              abtType: 
                cr.d('p') ?
                  `hzlDntz`
                : `vclDntz`,
              boxStlz: 
                cr.d('p') ?
                  a(`bc/${pz.sPz.crt.dffz.clr}5 bwl/4 dw/60 mb/0.5 pl/1`)
                : a(`bc/${pz.sPz.crt.dffz.clr}5 bwl/4 dw/40 mb/0.5 pl/1`),
              lblCz: {
                boxStlz: a('dw/20'),
                textz: {
                  pfx: '利用する時間帯',
                  stlz: a(`tc/${pz.sPz.crt.dffz.clr}7`),
                }
              },
              cttCz: {
                oClds: [
                  cr.c(CbxC.MM, {
                    key: -10,
                    boxStlz: a('dh/f f/1'),
                    cz: {
                      bEdit: true,
                      ls: $i111s,
                      vlez: _zonez,
                      onChg: (_dz: ht.dz) => {
                        pz.cz.i1zz?.i1z1s?.map( (_i1z1z: ht.dz) => {
                          const _i111_fst = _i1z1z.i1z1i1111f;
                          if (_dz[_i111_fst]) {
                            _i1z1z._dlt = _dz[_i111_fst] * -1;
                          }
                          else {
                            _i1z1z._dlt = 1;
                          }
                        });
                        icm.udtI1z3z({
                          i1zz: pz.cz.i1zz,
                          i17rs: pz.cz.i17rs,
                          role: 'd',
                        });
                        _udtThis();
                      }
                    },
                  })
                ]
              }
            })
            : null,

            $i10rz?._fst > 0 && $i10rz?.i10ra1100i?
            cr.c(TextC.N, {
              key: -70,
              boxStlz: 
                cr.d('p') ?
                  a(`dw/60 mb/2`)
                : a(`dw/40 mb/2`),
              textz: {
//                pfx: `※ 1回の${pz.sPz.crt.dffz.tgt}で指定可能な最大コマ数は、連続${$i10rz.i10ra1100i}コマまでです。`,
                pfx: `※ 1回の${pz.sPz.crt.dffz.tgt}で指定可能な最大コマ数は、${$i10rz.i10ra1100i}コマまでです。`,
                stlz: a('tc/rd5 ts/s'),
              }
            })
            : null,

            _gUserz.crt.i19rz.i19ra2210i == 1 &&
            hf.f(pz.cz.i1zz?.i1zrz?.i1zrd3100s) && $i10rz?._fst > 0 ?
            cr.c(LblC.N, {
              key: -80,
              abtType: 
                cr.d('p') ?
                  `hzlDntz`
                : `vclDntz`,
              boxStlz: 
                cr.d('p') ?
                  a(`bc/${pz.sPz.crt.dffz.clr}5 bwl/4 dw/60 mb/2 pl/1`)
                : a(`bc/${pz.sPz.crt.dffz.clr}5 bwl/4 dw/40 mb/2 pl/1`),
              lblCz: {
                boxStlz: a('dw/20'),
                textz: {
                  pfx: 
                    cr.d('p') ?
                      '利用する\n備品・駐車場'
                    : '利用する備品・駐車場',
                  stlz: a(`tc/${pz.sPz.crt.dffz.clr}7`),
                }
              },
              cttCz: {
                oClds: [
                  cr.c(icvI17___Tz.T, {
                    key: -20,
                    boxStlz: a(`dw/40`),
                    sPz: pz.sPz,
                    cz: {
                      bEdit: true,
                      bFee: false,
                      i1zz: pz.cz.i1zz,
                      _31r_fst: pz.sPz.crt._31rz?._fst,
                      clr: pz.sPz.crt.dffz.clr,
                      i18r_fst: _gUserz.crt.i18rz._fst,
//                      clr: 'bl',
                    },
                  })
                ]
              }
            })
            : null,

            $_51Rw.S01999232 == 1 &&
            hf.f(pz.cz.i1zz?.i1zrz?.i1zrd3100s) && $i10rz?._fst > 0 ?
            cr.c(LblC.N, {
              key: -90,
              abtType: 
                cr.d('p') ?
                  `hzlDntz`
                : `vclDntz`,
              boxStlz: 
                cr.d('p') ?
                  a(`bc/${pz.sPz.crt.dffz.clr}5 bwl/4 dw/60 mb/0.5 pl/1`)
                : a(`bc/${pz.sPz.crt.dffz.clr}5 bwl/4 dw/40 mb/0.5 pl/1`),
              lblCz: {
                boxStlz: a('dw/20'),
                textz: {
                  pfx: '施設への\n伝達事項（任意）',
                  stlz: a(`tc/${pz.sPz.crt.dffz.clr}7`),
                }
              },
              cttCz: {
                oClds: [
                  cr.c(IptC.S, {
                    key: -10,
                    cz: {
                      bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                      iptType: 'text',
                      vle: pz.cz.i1zz?.i1zrz.i1zra8100s,
                      onChg: ( _s: ht.s ) => {
                        pz.cz.i1zz.i1zrz.i1zra8100s = _s;
                      }
                    }
                  })
                ]
              }
            })
            : undefined,

            $_51Rw.S01999232 == 1 && hf.f($_51Rw.S01999242) &&
            hf.f(pz.cz.i1zz?.i1zrz?.i1zrd3100s) && $i10rz?._fst > 0 ?
            cr.c(TextC.N, {
              key: -70,
              boxStlz: 
                cr.d('p') ?
                  a(`dw/60 mb/2`)
                : a(`dw/40 mb/2`),
              textz: {
                pfx: $_51Rw.S01999242,
                stlz: a('tc/rd5 ts/s'),
              }
            })
            : null,

          ]
        }),

        cr.c(BoxC.N, {
          key: -70,
          abtType: 'btnAreaz',
          oClds: [

            cr.c(TextC.N, {
              key: -10,
              abtType: 'wrn2z',
              boxStlz: a('dw/100 mb/2 pv/0.5 sc/yw3'),
              textz: {
                pfx: 
                  cr.d('p') ?
                    `※ 次の画面で確定ボタンを押すまで${pz.sPz.crt.dffz.tgt}は完了しません`
                  : `※ 次の画面で確定ボタンを押すまで\n${pz.sPz.crt.dffz.tgt}は完了しません`,
                stlz: a('tc/lt9')
              },
            }),

            cr.c(BtnC.N, {
              key: -20,
              abtType: 'nextCmnz',
              boxStlz: a('dh/10 mb/2'),
              lblCz: {
                textz: {
                  pfx: `この条件で${pz.sPz.crt.dffz.tgt}\n（${pz.sPz.crt.dffz.tgt}確認画面へ）`,
                },
              },
              rhtIconCz: {
                iconPtyz: a('icn/right-arrow'),
              },
              pslPtyz: {
                onPress: async () => {
                  icm.udtI1z3z({
                    i1zz: pz.cz.i1zz,
                    i17rs: pz.cz.i17rs,
                    role: 'd',
                  });
                  const _b = await icvI1z___Mz.chkI1zAsync({
                    role: 'd',
                    ctt: pz.sPz.crt.ctt,
                    _31r_fst: pz.sPz.crt._31rz._fst,
                    i1zz: pz.cz.i1zz,
                    i10rs: pz.cz.i10rs,
                    i17rs: pz.cz.i17rs,
                    sMsgz: _sMsgz,
                    step: 1,
                  });
                  if (_b) {
                    pz.sPz.set({
                      steps: [1, 1],
                    });
                  }
                },
              },
            }),

          ]
        })

      ]
    })
  );
};
